import { render, staticRenderFns } from "./Wordlists.vue?vue&type=template&id=3f6c65dd"
import script from "./Wordlists.vue?vue&type=script&lang=js"
export * from "./Wordlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports